/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {EnvironmentService} from "@irian-ro/util-environment";
import { AbstractResourceService, JsonApiListResourceMetadataBase, JsonApiResource } from '@irian-ro/abstract-resource';
import { DelAddressListVO } from '@well/domain';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DelAddressListResourceService
  extends AbstractResourceService<DelAddressListVO, any, any, any> {

  constructor(httpClient: HttpClient,
              environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('delAddressListUrl'),
      DelAddressListVO,
      DelAddressListVO
    );
  }

  findAllAddressesForCustomer(customerUuid: string,)
              : Observable<JsonApiResource<DelAddressListVO[], JsonApiListResourceMetadataBase>> {
    return <Observable<JsonApiResource<DelAddressListVO[], JsonApiListResourceMetadataBase>>>this.httpClient?.get(`${this.url}/customer/${customerUuid}`);
  }
}
